import { Box, Tab, Tabs } from '@mui/material'
import { grey } from '@mui/material/colors'
import Drawer from '@mui/material/Drawer'
import React, { useEffect, useMemo } from 'react'
import { defaultDrawerSX } from '../../../const'
import { useTabsControl } from '../../../hooks/useTabsControl'
import { useAuthContext } from '../../context/AuthProvider'
import { getTitle } from '../../tabs/TabsTitle'
import ProfileBanner from '../article/ProfileBanner'
import DrawerContainer from '../common/DrawerContainer'
import DrawerHeader from '../common/DrawerHeader'
import ProfileBasicInfoForm from './forms/ProfileBasicInfoForm'
import ProfileTrainingDetailsForm from './forms/ProfileTrainingDetailsForm'

interface Props {
  isOpen: boolean
  handleClose: () => void
  userId: number
}

const ProfileDrawer = (props: Props) => {
  const { isOpen, handleClose } = props

  const firstTab = <ProfileBasicInfoForm onClose={handleClose} userId={props.userId} />
  const secondTab = <ProfileTrainingDetailsForm onClose={handleClose} />

  const { selectedTab, handleChangeSelectedTab, setSelectedTab } = useTabsControl('first')

  const renderedTab = useMemo(() => {
    switch (selectedTab) {
      case 'first':
        return firstTab
      case 'second':
        return secondTab
    }
    return null
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab])

  useEffect(() => {
    if (!isOpen) {
      setSelectedTab('first')
    }
  }, [isOpen, setSelectedTab])

  const { profileName, isTrainee, isCaregiver, user } = useAuthContext()

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose} sx={defaultDrawerSX}>
      {isOpen ? (
        <DrawerContainer isOpen={isOpen} hasData loading={false} handleClose={handleClose}>
          <DrawerHeader handleClose={handleClose}>
            {isCaregiver
              ? 'Your Caregiving Membership Profile'
              : 'Your Training Membership Profile'}
          </DrawerHeader>

          <ProfileBanner profileName={profileName} typeOfProfile="caregiver" role={user?.role} />

          <Tabs
            value={selectedTab}
            onChange={handleChangeSelectedTab}
            textColor="secondary"
            indicatorColor="secondary"
            variant="fullWidth"
            sx={{ background: grey[100] }}
          >
            <Tab value="first" label={getTitle('About Me')} />
            {isTrainee && <Tab value="second" label={getTitle('Registration')} />}
          </Tabs>
          <Box mt={2}>{renderedTab}</Box>
        </DrawerContainer>
      ) : null}
    </Drawer>
  )
}

export default ProfileDrawer
